var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PackageCardGrid',{attrs:{"packages":_vm.packages},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('ServicesCoverageFooter')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }